<script lang="ts">
  let {
    liked = false,
    count = 0,
    showCount = true,
    disabled = false,
    ontoggle
  }: {
    liked?: boolean;
    count?: number;
    showCount?: boolean;
    disabled?: boolean;
    ontoggle?: () => void;
  } = $props();

  let isAnimating = $state(false);

  function handleClick() {
    if (disabled) return;

    ontoggle?.();

    if (!liked) {
      isAnimating = true;
      setTimeout(() => isAnimating = false, 300);
    }
  }
</script>

<button
  onclick={handleClick}
  class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-xl transition-all duration-200
         {liked
           ? 'bg-error/10 text-error hover:bg-error/20'
           : 'bg-surface-tertiary text-content-tertiary hover:bg-gray-200 dark:hover:bg-dark-elevated hover:text-gray-700 dark:hover:text-dark-text-medium'}"
  class:cursor-not-allowed={disabled}
  class:opacity-50={disabled}
  {disabled}
  aria-label={liked ? '좋아요 취소' : '좋아요'}
  aria-pressed={liked}
>
  <svg
    class="w-5 h-5 transition-transform {isAnimating ? 'animate-bounce-heart' : ''}"
    fill={liked ? 'currentColor' : 'none'}
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
    />
  </svg>
  {#if showCount}
    <span class="text-sm font-medium">{count}</span>
  {/if}
</button>
